import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Common {
	constructor() {
		
	}

	init() {
		this.bindEvents();

		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			$('.controls.collapse').addClass('show');
			$('.js-toggle').removeClass('collapsed');
		}
	}

	bindEvents() {
		$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('.js-toggle').on('click', e => { this.smoothScroll(e); });
	}

	smoothScroll(e) {
		let link = $(e.currentTarget);
		let target = $(link.attr('href'));

		// Does a scroll target exist?
		if (target.length) {

			// Only prevent default if animation is actually gonna happen
			e.preventDefault();

			$('html, body').animate({
				scrollTop: target.offset().top - 150
			}, 1000);
		}
	}
}

export default Common;